class ProductCustomizationItem extends HTMLElement {
  constructor() {
    super();
  }

  get key() {
    return this.dataset.key;
  }

  get sectionID() {
    return this.dataset.sectionId;
  }

  get productFormID() {
    return this.dataset.productFormId;
  }

  async connectedCallback() {
    // this.items = await this.getItems();
    
    // this.variantOptions = this.querySelector('.variant-options');
    // if (this.variantOptions) {
    //   this.variantOptions.innerHTML = this.buildHTML();
    // }

    this.initScrollDetection();
  }

  initScrollDetection() {
    const wrapper = this.querySelector('.variant-options-wrapper');
    const scrollElement = this.querySelector('.variant-options');
    if (!wrapper || !scrollElement) return;

    const checkIfAtBottom = () => {
      const isAtBottom = Math.abs(scrollElement.scrollHeight - scrollElement.clientHeight - scrollElement.scrollTop) < 1;
      if (isAtBottom) {
        wrapper.classList.add('is-at-bottom');
      } else {
        wrapper.classList.remove('is-at-bottom');
      }
    };

    const checkIfScrollable = () => {
      if (scrollElement.scrollHeight <= scrollElement.clientHeight) {
        wrapper.classList.add('is-at-bottom');
      } else {
        checkIfAtBottom();
      }
    };

    checkIfScrollable();

    scrollElement.addEventListener('scroll', checkIfAtBottom);
  }
  async getItems() {
    console.log(`Fetching customization data for key: ${this.key} from Storefront API`);
    
    try {
      // Get product handle from the page URL or data attribute
      const productHandle = this.getProductHandle();
      
      if (!productHandle) {
        console.error('Product handle not found');
        return [];
      }
      
      // Build identifiers array for the main key and its variants (_2, _3)
      const namespace = 'customizations';
      const identifiers = [
        { namespace: namespace, key: this.key },
        { namespace: namespace, key: `${this.key}_2` },
        { namespace: namespace, key: `${this.key}_3` }
      ];
      
      // Fetch product metafields
      const product = await this.getProductMetafields(productHandle, identifiers);
      
      if (!product) {
        console.error('Product not found');
        return [];
      }
      
      console.log('Product ID:', product.id);
      console.log('Product title:', product.title);
      
      // Parse metafields and combine references
      let items = [];
      
      if (product.metafields) {
        for (const metafield of product.metafields) {
          if (metafield) {
            console.log(
              `[${metafield.namespace}.${metafield.key}] (${metafield.type})`
            );
            
            // Check if metafield has references (for file_reference types)
            if (metafield.references && metafield.references.nodes) {
              const nodes = metafield.references.nodes;
              
              nodes.forEach(node => {
                if (node.__typename === 'MediaImage' && node.image) {
                  // For MediaImage, use the image URL
                  items.push(node.image.url);
                  console.log(`  - MediaImage: ${node.image.url}`);
                } else if (node.__typename === 'GenericFile' && node.url) {
                  // For GenericFile, use the file URL
                  items.push(node.url);
                  console.log(`  - GenericFile: ${node.url}`);
                }
              });
            } 
            // Fallback: Try parsing value as JSON for non-reference types
            else if (metafield.value) {
              try {
                const parsedValue = JSON.parse(metafield.value);
                if (Array.isArray(parsedValue)) {
                  items = items.concat(parsedValue);
                  console.log(`  - Parsed value: ${parsedValue.length} items`);
                }
              } catch (e) {
                // Value is not JSON, might be a simple string
                console.log(`  - Simple value: ${metafield.value}`);
              }
            }
          }
        }
      } else {
        console.log('No metafields returned');
      }
      
      return items;
      
    } catch (error) {
      console.error('Error fetching product metafields:', error);
      return [];
    }
  }
  
  async getProductMetafields(handle, identifiers) {
    const STOREFRONT_ACCESS_TOKEN = "30ea1783cbe83b0c9d73c9a66548e708";
    
    const query = `
      query GetProductMetafields($handle: String!, $identifiers: [HasMetafieldsIdentifier!]!) {
        product(handle: $handle) {
          id
          title
          metafields(identifiers: $identifiers) {
            namespace
            key
            type
            value
            references(first: 250) {
              nodes {
                __typename
                ... on MediaImage {
                  id
                  image {
                    url
                    altText
                    width
                    height
                  }
                }
                ... on GenericFile {
                  id
                  mimeType
                  url
                }
              }
            }
          }
        }
      }
    `;
    
    const variables = {
      handle: handle,
      identifiers: identifiers
    };
    
    const response = await fetch(window.Shopify.routes.root + 'api/2024-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({
        query: query,
        variables: variables
      })
    });
    
    const result = await response.json();
    
    if (result.errors) {
      console.error('GraphQL errors:', result.errors);
      throw new Error('Failed to fetch product metafields');
    }
    
    return result.data?.product || null;
  }
  
  getProductHandle() {
    // Try to get product handle from various sources
    
    // 1. From URL path (e.g., /products/product-handle)
    const pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    if (pathMatch) {
      return pathMatch[1];
    }
    
    // 2. From window.ShopifyAnalytics (if available)
    if (window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.product_id) {
      return window.ShopifyAnalytics.meta.page.resourceHandle;
    }
    
    // 3. From meta tag
    const metaTag = document.querySelector('meta[property="og:url"]');
    if (metaTag) {
      const urlMatch = metaTag.content.match(/\/products\/([^\/\?]+)/);
      if (urlMatch) {
        return urlMatch[1];
      }
    }
    
    return null;
  }
  buildHTML() {
    let html = '';
    if(!this.key) return html;
    this.items.forEach((item, index) => {
      const item_image_url = item + '&width=80';
      let option_name = '';
      try {
        option_name = item.split('?')[0].split('__')[1].split('.')[0].replace('_', ' ').replace('files/', '');
      } catch(e) {
        console.log(item);
      }
      let background = '#65656C';
      if (item_image_url) {
        background = 'url(' + item_image_url + ')';
      }
      html += `
        <input
          type="radio"
          id="${this.sectionID}-${this.key}-${index}"
          name="${this.sectionID}-${this.key}"
          value="${option_name}"
          class="swatch-input__input"
          ${index === 0 ? 'checked' : ''}
          data-customization-title="${this.key.replace('_', ' ').replace('image list', '')}"
          data-product-customization="#${this.productFormID}-item-${this.key}"
        >
        <label
          for="${this.sectionID}-${this.key}-${index}"
          title="${option_name}"
          class="swatch-input__label swatch-input__label--square"
        >
          <span
            class="swatch"
            style="                        --swatch--background: ${background} ;"
          ></span>
        </label>
      `;
    });
    return html;
  }
}

customElements.define('product-customization-item', ProductCustomizationItem);

// Global function to handle scroll detection for all variant-options elements
window.initVariantOptionsScroll = function() {
  const scrollElements = document.querySelectorAll('.variant-options');
  
  scrollElements.forEach(scrollElement => {
    const wrapper = scrollElement.closest('.variant-options-wrapper');
    if (!wrapper) return;

    const checkIfAtBottom = () => {
      const isAtBottom = Math.abs(scrollElement.scrollHeight - scrollElement.clientHeight - scrollElement.scrollTop) < 1;
      if (isAtBottom) {
        wrapper.classList.add('is-at-bottom');
      } else {
        wrapper.classList.remove('is-at-bottom');
      }
    };

    const checkIfScrollable = () => {
      if (scrollElement.scrollHeight <= scrollElement.clientHeight) {
        wrapper.classList.add('is-at-bottom');
      } else {
        checkIfAtBottom();
      }
    };

    checkIfScrollable();

    scrollElement.addEventListener('scroll', checkIfAtBottom);
  });
}

// Re-initialize when new content is added (for dynamic content)
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.classList?.contains('variant-options')) {
          initVariantOptionsScroll();
        } else if (node.querySelector?.('.variant-options')) {
          initVariantOptionsScroll();
        }
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});